
import CareersNavbar from './components/CareersNavbar';
import JobApplication from './components/JobApplication';

export default function CareersPage() {
  return (
    <div className="min-h-screen bg-white">
      <CareersNavbar />
      <div className="pt-20">
        <JobApplication />
      </div>
    </div>
  );
}
